import { refreshMunicipalPropertyManagement } from "@/domain/municipal-property/lib/refresh-municipal-property-management";
import { ArchiveMunicipalPropertyMutation, ReactivateMunicipalPropertyMutation } from "@/graphql/generated/graphql";
import { createOperationClient } from "@/services/react-query.service/graphql-client";
import { QueryClient, useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";

import { ARCHIVE_MUNICIPAL_PROPERTY_MUTATION_DOCUMENT } from "./archive-municipal-property-mutation.gql";
import { REACTIVATE_MUNICIPAL_PROPERTY_MUTATION_DOCUMENT } from "./reactivate-municipal-property-mutation.gql";

export function useSetMunicipalPropertyArchived({
  workspaceId,
  propertyId,
}: {
  workspaceId: string;
  propertyId: string;
}): UseMutationResult<ArchiveMunicipalPropertyMutation | ReactivateMunicipalPropertyMutation, Error, boolean> {
  const queryClient: QueryClient = useQueryClient();
  return useMutation({
    mutationFn: async (
      isArchived: boolean,
    ): Promise<ArchiveMunicipalPropertyMutation | ReactivateMunicipalPropertyMutation> =>
      isArchived
        ? createOperationClient("ArchiveMunicipalProperty").request(ARCHIVE_MUNICIPAL_PROPERTY_MUTATION_DOCUMENT, {
            id: propertyId,
          })
        : createOperationClient("ReactivateMunicipalProperty").request(REACTIVATE_MUNICIPAL_PROPERTY_MUTATION_DOCUMENT, {
            id: propertyId,
          }),
    onSuccess: (): Promise<void> =>
      refreshMunicipalPropertyManagement({ queryClient, scope: { workspaceId, propertyIdList: [propertyId] } }),
  });
}
